import React from 'react';

const JBLogo = () => (
  <svg width="35px" height="25px" viewBox="0 0 35 25" version="1.1">
    <g id="Blog" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Blog-—-Post-(Desktop)"
        transform="translate(-882.000000, -4631.000000)"
        fill="#27919C"
      >
        <g id="Logos/Icon/Color" transform="translate(882.000000, 4631.000000)">
          <g id="joybird">
            <path
              d="M23.4423958,10.1288179 C20.2225022,15.3678617 13.8219821,14.746938 5.14397629,9.54670195 C2.9450246,8.26604681 1.17800984,9.81835607 0.628271914,11.6811272 C-0.589004919,6.5196989 2.39528667,5.0450051 5.53664624,6.86896848 C12.7617732,10.982588 18.2591525,15.3678617 23.4423958,10.1288179 Z"
              id="Path"
              fillRule="nonzero"
            />
            <path
              d="M19.2800944,18.8993653 C27.8010322,17.8127488 30.4319208,10.6333184 32.6308725,2.48369482 L35.1046932,1.97919431 L32.9057415,1.4746938 C31.6491977,0.194038658 30.3533868,-0.0388077315 29.214644,0.388077315 C27.9973672,0.853770093 27.1727603,1.94038658 26.5837554,3.02700306 C24.4240707,7.10181487 24.7382066,13.6215138 18.2591525,14.4752839 C13.7827151,15.0962076 9.34554472,13.0393978 4.67277236,10.2064334 C2.86649061,9.11981691 -0.196334973,11.6811272 2.55235465,13.8931679 C6.20418515,16.8425555 11.3874284,19.3262503 17.6701476,19.0545962 C17.8272156,19.520289 18.2591525,21.1890214 17.7486816,22.8189461 C15.5497299,23.8279472 9.93454964,23.8279472 9.10994275,24.8757559 L27.8010322,24.8757559 C26.9371583,23.8279472 21.3612451,23.8667549 19.1622934,22.8189461 C18.5732885,20.8785596 19.2800944,18.8993653 19.2800944,18.8993653 L19.2800944,18.8993653 Z M31.414381,0.970193288 C32.0332943,0.970193288 32.4753752,1.40710367 32.4753752,2.01877819 C32.4753752,2.63045272 32.0332943,3.0673631 31.414381,3.0673631 C30.7954678,3.0673631 30.3533868,2.63045272 30.3533868,2.01877819 C30.3533868,1.40710367 30.7954678,0.970193288 31.414381,0.970193288 Z"
              id="Shape"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default JBLogo;
